import Vue from 'vue';
import dayjs from 'dayjs';
import 'dayjs/locale/en';
import 'dayjs/locale/lt';
import 'dayjs/locale/ru';
import utc from 'dayjs/plugin/utc';

dayjs.locale('lt');
dayjs.extend(utc);

const formatDate = (val: string) => val && dayjs(val).format('YYYY MM DD');
const formatDateWithTime = (val: string, locale = 'lt') => {
  let format = 'YYYY [m.] MMMM DD [d.] HH:mm';

  if (locale !== 'lt') {
    dayjs.locale(locale);
  }

  switch (locale) {
    case 'en':
      format = 'YYYY MMMM DD HH:mm';
      break;
    case 'ru':
      format = 'DD MMMM YYYY [г.] HH:mm';
      break;
  }

  return val && dayjs(val).format(format);
};
const formatLongDate = (val: string) => val && dayjs(val).format('YYYY [m.] MMMM DD [d.]');
const formatCustomDate = (val: string | number, formatType: string) => String(val && formatType && dayjs(val).format(formatType));
const convertToLocal = (val: string) => val && dayjs(val).format();
const convertToISO = (val: string) => val && dayjs(val).utc().format();

Vue.filter('formatDate', formatDate);
Vue.filter('formatDateWithTime', formatDateWithTime);
Vue.filter('formatLongDate', formatLongDate);
Vue.filter('convertToLocal', convertToLocal);
Vue.filter('convertToISO', convertToISO);
Vue.filter('formatCustomDate', formatCustomDate);

export { formatDate, formatDateWithTime, formatLongDate, convertToLocal, convertToISO };
